export enum NotificationTranslationKey {
    CHALLENGE = 'challenge_complete',
    EMAIL = 'new_message',
}
